<app-generic-dashboard
  [pageTitle]="'work comp partner portal'"
  [dashboardType]="dashboardType"
  [patientSearchInputs]="patientSearchInputs"
  [contactInfoInputs]="contactInfoInputs"
  [fetchAppointments$]="fetchAppointments$">
</app-generic-dashboard>
